import { useState, useEffect } from "react";
import Checkbox from "./Checkbox";
import LinkExternal from "../assets/img/icons/link-external.svg";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

export default function CGUCheckbox({
    onChange,
    id = "accept-cgu",
    color,
    defaultChecked = false,
    boater = true,
    cguWarningTrigger,
    addToast,
    t: propT,
}) {
    const { t: hookT, i18n } = useTranslation();
    const t = propT || hookT;
    const [checked, setChecked] = useState(defaultChecked);

    const lang = i18n?.language || "en";
    const cguHref = `/pdf/${lang}/cgu${boater ? "-beepp" : ""}.pdf`;

    useEffect(() => {
        if (cguWarningTrigger && typeof addToast === "function") {
            addToast(t("must_accept"), {
                appearance: "warning",
                autoDismiss: true,
                autoDismissTimeout: 4000,
            });
        }
    }, [cguWarningTrigger, addToast, t]);

    const handleChange = (e) => {
        const newChecked = e.target.checked;
        setChecked(newChecked);
        if (onChange) {
            onChange(newChecked);
        }
    };

    return (
        <Checkbox
            checked={checked}
            onChange={handleChange}
            id={id}
            color={color}
        >
            <span className="checkbox-cgu-inline">
                {t("i_accept")}{" "}
                <a
                    href={cguHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="checkbox-cgu-link"
                >
                    <span className="checkbox-cgu-link-text">
                        {t("general_terms_of_use")}
                        <img
                            src={LinkExternal}
                            alt={t("Open in new tab")}
                            className="checkbox-cgu-link-icon"
                        />
                    </span>
                </a>
            </span>
        </Checkbox>
    );
}

CGUCheckbox.propTypes = {
    onChange: PropTypes.func,
    id: PropTypes.string,
    color: PropTypes.string,
    defaultChecked: PropTypes.bool,
    boater: PropTypes.object,
    cguWarningTrigger: PropTypes.number,
    addToast: PropTypes.func,
    t: PropTypes.func,
};
